// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"60":"cec685e9","88":"9bf45987","198":"2c25b3b6","199":"e6a6aaff","251":"cec685e9","352":"4d871ba0","501":"d6347f3a","536":"cec685e9","589":"cec685e9","641":"08e59377","741":"cec685e9","797":"cec685e9","924":"cec685e9","936":"cec685e9","975":"d5bc7091","981":"cec685e9"}[chunkId] + ".css";
};